import React from 'react';
import MaterialPopover, { PopoverProps } from '@mui/material/Popover';

import Transition from '../Transition';
import { DEFAULT_TRANSITION_DURATION, DEFAULT_TRANSITION_PROPS } from './consts';

const Popover = (props: PopoverProps) => (
  <MaterialPopover
    // @ts-ignore
    TransitionComponent={Transition}
    // @ts-ignore
    TransitionProps={DEFAULT_TRANSITION_PROPS}
    transitionDuration={DEFAULT_TRANSITION_DURATION}
    {...props}
  />
);

export default Popover;
